import { lazy } from "react";

const ProfilePage = lazy(() => import("./ui/ProfilePage/ProfilePage"));

export { ProfilePage };
